<template>
  <div>
    <footer tabindex="-1" v-if="displayMode === 'full'" id="site-footer">
      <section class="top-row-content">
        <nav class="top-link-group">
          <h2 class="h6">{{ footerData.columnOneHeading }}</h2>
          <ul>
            <li v-for="item in footerData.columnOneLinks" :key="item.displayText">
              <a :href="item.url.tokenSwap()">{{ item.displayText }}</a>
            </li>
          </ul>
        </nav>

        <nav>
          <h2 class="h6">{{ footerData.columnTwoHeading }}</h2>
          <ul>
            <li v-for="item in footerData.columnTwoLinks" :key="item.displayText">
              <a :href="item.url.tokenSwap()">{{ item.displayText }}</a>
            </li>
          </ul>
        </nav>
      </section>

      <section class="bottom-row-content">
        <div class="abn-afsl">
          <p v-if="currentDevice != DeviceTypes.MOBILE">&copy; {{ new Date().getFullYear() }} Defence Health Ltd | ABN {{ footerData.abn }} AFSL {{ footerData.afsl }}</p>
          <p v-else>
            &copy; {{ new Date().getFullYear() }} Defence Health Ltd |
            <br />
            ABN {{ footerData.abn }}
            <br />
            AFSL {{ footerData.afsl }}
          </p>
        </div>

        <nav class="contact-us">
          <h2>{{ footerData.columnThreeHeading }}</h2>
          <div class="social-icons">
            <a
              v-for="item in footerData.columnThreeLinks"
              :key="item.title"
              :href="item.url.tokenSwap()"
              :title="item.title"
              :aria-label="item.title"
              target="_blank"
              rel="nofollow noreferrer"
              class="social-networks"
            >
              <svg aria-hidden="true">
                <use :xlink:href="'/assets/public/images/icons.svg#' + item.iconId" />
              </svg>
            </a>
          </div>
        </nav>

        <router-link v-if="!isHelpHq" :to="toHome" class="logo">
          <img :src="footerData.dhlLogo.replace(/^~/, '')" :alt="footerData.dhlLogoAltText" />
        </router-link>
        <a v-else :href="toHome.params.policyNumber" class="logo">
          <img :src="footerData.dhlLogo.replace(/^~/, '')" :alt="footerData.dhlLogoAltText" />
        </a>
      </section>
      <a id="back-to-top" href="#site-header" class="skip-to-button">Back to top</a>
    </footer>
    <footer v-else id="site-footer" class="condensed-display">
      <section class="bottom-row-content">
        <router-link v-if="!isHelpHq" :to="toHome" class="logo condensed">
          <img :src="footerData.dhlLogo.replace(/^~/, '')" :alt="footerData.dhlLogoAltText" />
        </router-link>
        <a v-else :href="toHome.params.policyNumber" class="logo condensed">
          <img :src="footerData.dhlLogo.replace(/^~/, '')" :alt="footerData.dhlLogoAltText" />
        </a>

        <div class="abn-afsl">
          <p v-if="currentDevice != DeviceTypes.MOBILE">&copy; {{ new Date().getFullYear() }} Defence Health Ltd | ABN {{ footerData.abn }} AFSL {{ footerData.afsl }}</p>
          <p v-else>
            &copy; {{ new Date().getFullYear() }} Defence Health Ltd |
            <br />
            ABN {{ footerData.abn }}
            <br />
            AFSL {{ footerData.afsl }}
          </p>
        </div>
      </section>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VUEX_GENERAL } from '@/constants/VuexConstants';
import { getDisplayMode, getCurrentDeviceLayout } from '@/utils';
import { HOME } from '@/router/routeNames';
import DeviceTypes from '@/enums/DeviceTypes';

export default {
  name: 'FooterComponent',

  props: {
    footerData: {
      type: Object,
      required: true,
    },
    isHelpHq: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentDevice: DeviceTypes.DESKTOP,
      DeviceTypes,
    };
  },
  beforeMount() {
    // initialism current device layout
    this.resizeHandler();
  },

  mounted() {
    window.addEventListener('resize', this.resizeHandler);
  },

  unmounted() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  computed: {
    ...mapGetters({
      policyNumber: VUEX_GENERAL.GETTERS.getCurrentPolicyNumber,
    }),

    displayMode() {
      if (this.isHelpHq === false) {
        return getDisplayMode(this.$route.meta.displayMode);
      }
      return 'full';
    },

    toHome() {
      return {
        name: HOME,
        params: {
          policyNumber: this.policyNumber,
        },
      };
    },
  },
  methods: {
    resizeHandler() {
      // This is to fetch the current device layout so that appropriate version of my recommendation is shown
      this.currentDevice = getCurrentDeviceLayout(window.innerWidth);
    },
  },
};
</script>
<style lang="scss" scoped>
#site-footer {
  position: relative;
}

.condensed-display {
  background-color: $GREY_25;
  color: $GREY_700 !important;
}
</style>
